import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { trimTrailingZeroes } from "../uttils/common";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F4F4F4",
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    border: "none",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  //   "&:nth-of-type(odd)": {
  //     backgroundColor: theme.palette.action.hover,
  //   },
  // hide last border
  //   "&:last-child td, &:last-child th": {
  //     border: 0,
  //   },
}));

export default function CustomizedTable(props) {
  const live = props?.live;

  return (
    <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Batsman</StyledTableCell>
            <StyledTableCell align="right">R</StyledTableCell>
            <StyledTableCell align="right">B</StyledTableCell>
            <StyledTableCell align="right">4s</StyledTableCell>
            <StyledTableCell align="right">6s</StyledTableCell>
            <StyledTableCell align="right">SR</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!live?.teamBatting?.striker?.wicketTypeId && (
            <StyledTableRow key={live?.teamBatting?.striker?.playerName}>
              <StyledTableCell component="th" scope="row">
                {live?.teamBatting?.striker?.playerName}
              </StyledTableCell>
              <StyledTableCell align="right">
                {live?.teamBatting?.striker?.battingRuns || 0}
              </StyledTableCell>
              <StyledTableCell align="right">
                {live?.teamBatting?.striker?.ballsPlayed || 0}
              </StyledTableCell>
              <StyledTableCell align="right">
                {live?.teamBatting?.striker?.noOf4s || 0 + "s"}
              </StyledTableCell>
              <StyledTableCell align="right">
                {live?.teamBatting?.striker?.noOf6s || 0 + "s"}
              </StyledTableCell>
              <StyledTableCell align="right">
                {trimTrailingZeroes(
                  live?.teamBatting?.striker?.getSr().toFixed(2)
                )}
              </StyledTableCell>
            </StyledTableRow>
          )}

          {!live?.teamBatting?.nonStriker?.wicketTypeId && (
            <StyledTableRow key={live?.teamBatting?.nonStriker?.playerName}>
              <StyledTableCell component="th" scope="row">
                {live?.teamBatting?.nonStriker?.playerName}
              </StyledTableCell>
              <StyledTableCell align="right">
                {live?.teamBatting?.nonStriker?.battingRuns || 0}
              </StyledTableCell>
              <StyledTableCell align="right">
                {live?.teamBatting?.nonStriker?.ballsPlayed || 0}
              </StyledTableCell>
              <StyledTableCell align="right">
                {live?.teamBatting?.nonStriker?.noOf4s || 0 + "s"}
              </StyledTableCell>
              <StyledTableCell align="right">
                {live?.teamBatting?.nonStriker?.noOf6s || 0 + "s"}
              </StyledTableCell>
              <StyledTableCell align="right">
                {trimTrailingZeroes(
                  live?.teamBatting?.striker?.getSr().toFixed(2)
                )}
              </StyledTableCell>
            </StyledTableRow>
          )}
        </TableBody>
        <TableHead>
          <TableRow>
            <StyledTableCell>Bowlers</StyledTableCell>
            <StyledTableCell align="right">O</StyledTableCell>
            <StyledTableCell align="right">R</StyledTableCell>
            <StyledTableCell align="right">W</StyledTableCell>
            <StyledTableCell align="right">M</StyledTableCell>
            <StyledTableCell align="right">ECO</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {/* {rows.map((row) => (
            <StyledTableRow key={row.name}>
              <StyledTableCell component="th" scope="row">
                {row.name}
              </StyledTableCell>
              <StyledTableCell align="right">{row.calories}</StyledTableCell>
              <StyledTableCell align="right">{row.fat}</StyledTableCell>
              <StyledTableCell align="right">{row.carbs}</StyledTableCell>
              <StyledTableCell align="right">{row.protein}</StyledTableCell>
            </StyledTableRow>
          ))} */}

          <StyledTableRow key={live?.teamBowling?.bowler?.playerName}>
            <StyledTableCell component="th" scope="row">
              {live?.teamBowling?.bowler?.playerName}
            </StyledTableCell>
            <StyledTableCell align="right">
              {trimTrailingZeroes(
                live?.teamBowling?.bowler?.getActualOvers()
              ) || 0}
            </StyledTableCell>

            <StyledTableCell align="right">
              {live?.teamBowling?.bowler?.getTotalBowlingRuns() || 0}
            </StyledTableCell>
            <StyledTableCell align="right">
              {live?.teamBowling?.bowler?.noOfWickets || 0}
            </StyledTableCell>
            <StyledTableCell align="right">
              {live?.teamBowling?.bowler?.maidenOvers || 0}
            </StyledTableCell>
            <StyledTableCell align="right">
              {trimTrailingZeroes(live?.teamBowling?.bowler?.getEconomyRate())}
            </StyledTableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
